import React from 'react';
import logoWhite from '../../assets/images/flexcoa-logo-condensed.png';
import logoGreen from '../../assets/images/flexcoa-logo-condensed-green.png';
import vpgLogo from '../../assets/images/vpg-health-logo.png';

// Shared layout for the sign-in pages (FECOA-2174): the flexCOA logo, the form
// on a plain surface, and the VPG Health logo underneath. `forceLight` keeps the
// page light for participant pages, which are always shown in light mode.
const AuthShell = ({ title, subtitle, children, footer, forceLight = false, maxWidth = 'max-w-md', icon = null }) => {
  const dk = (classes) => (forceLight ? '' : classes);
  return (
    <div className={`flex min-h-screen flex-col bg-gray-50 ${dk('dark:bg-gray-900')}`}>
      <div className="px-6 pt-8 sm:px-10">
        <img src={logoGreen} alt="flexCOA" className={`h-9 w-auto ${dk('dark:hidden')}`} />
        {!forceLight && <img src={logoWhite} alt="" aria-hidden="true" className="hidden h-9 w-auto dark:block" />}
      </div>

      <main className="flex flex-1 justify-center px-4 pb-12 pt-10 sm:px-6 sm:pt-16">
        <div className={`w-full ${maxWidth}`}>
          <div className={`rounded-xl border border-gray-200/80 bg-white px-6 py-8 shadow-card sm:px-8 ${dk('dark:border-white/[0.07] dark:bg-gray-800')}`}>
            {icon && (
              <div className={`mb-4 text-gray-400 [&>svg]:h-6 [&>svg]:w-6 ${dk('dark:text-gray-500')}`}>{icon}</div>
            )}
            {title && (
              <h1 className={`text-[22px] font-semibold tracking-tight text-gray-900 ${dk('dark:text-gray-50')}`}>{title}</h1>
            )}
            {subtitle && (
              <p className={`mt-1.5 text-sm leading-relaxed text-gray-600 ${dk('dark:text-gray-400')}`}>{subtitle}</p>
            )}
            <div className={title || subtitle ? 'mt-7' : ''}>{children}</div>
          </div>
          {footer && (
            <div className={`mt-6 text-center text-sm text-gray-600 ${dk('dark:text-gray-400')}`}>{footer}</div>
          )}
        </div>
      </main>

      <footer className={`flex flex-col items-center gap-3 border-t border-gray-200 px-6 py-6 text-xs text-gray-500 sm:flex-row sm:justify-between sm:px-10 ${dk('dark:border-gray-800 dark:text-gray-400')}`}>
        <span className="flex items-center gap-3">
          <img src={vpgLogo} alt="VPG Health" className={`h-7 w-auto ${dk('dark:brightness-0 dark:invert')}`} />
          <span>flexCOA is developed by VPG Health.</span>
        </span>
        <span>© {new Date().getFullYear()} VPG Health</span>
      </footer>
    </div>
  );
};

// Coloured message box used on these pages.
export const AuthNotice = ({ tone = 'info', children, role = 'alert' }) => {
  const tones = {
    info: 'border-info-500/25 bg-info-50 text-info-800 dark:bg-info-500/10 dark:text-info-400',
    success: 'border-success-500/25 bg-success-50 text-success-800 dark:bg-success-500/10 dark:text-success-400',
    warning: 'border-warning-500/30 bg-warning-50 text-warning-800 dark:bg-warning-500/10 dark:text-warning-400',
    danger: 'border-danger-500/25 bg-danger-50 text-danger-700 dark:bg-danger-500/10 dark:text-danger-400',
  };
  return (
    <div className={`rounded-lg border px-3.5 py-3 text-sm leading-relaxed ${tones[tone] || tones.info}`} role={role}>
      {children}
    </div>
  );
};

export default AuthShell;
